import { PlanungsinformationFromThemaRouter } from '../../../dtos';
import { content } from './TerminZeitlicherAblaufCard.content';

export const printZusatzinfo = (planungsinformation: PlanungsinformationFromThemaRouter): string =>
  planungsinformation.zusatzinfoAblauf ?? content.noInfoAvailable;
